import { GET_ROLES_SUCCESS } from '../actions/rolesAct'
import createReducer from '../createReducer'

const initialState = []

export default createReducer(initialState, {
  [GET_ROLES_SUCCESS](state, action) {
    return [].concat(action.payload)
  },
})
